module.exports = __webpack_public_path__ + "static/lp-lk-img-3-e4bdbabe5f42d754d68ec05c4a79d066.png";